<template>
  <div class="container is-fullhd">
    <div class="hero-body has-text-centered">
      <div class="container">
        <h1 class="title">
          Public API Mashup
        </h1>
        <h2 class="subtitle">
          I challenge you to click the button and create an app using the APIs that appear.
        </h2>
      </div>
    </div>
    <div class="section">
      <div class="columns" v-if="apis.length > 0">
        <api-card
          v-for="(api, index) in apis"
          :api="api"
          :key="index" />
      </div>
      <div class="columns" v-if="apis.length === 0">
        <query-card
          v-for="(query, index) in queries"
          :query="query"
          :index="index"
          :key="index" />
      </div>
      <div class="columns">
        <div class="column has-text-centered">
          <br />
          <b-button type="is-primary is-large" @click="feelinLucky">Feelin' Lucky</b-button>
          <br />
          <b-button type="is-text" @click="reset">Reset</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ApiCard from '../components/ApiCard.vue';
import QueryCard from '../components/QueryCard.vue';

export default {
  name: 'Main',
  components: {
    ApiCard,
    QueryCard,
  },
  computed: {
    ...mapState([
      'apis',
      'queries',
    ]),
  },
  methods: {
    ...mapActions([
      'feelinLucky',
      'reset',
    ]),
  },
  mounted() {
    this.$store.dispatch('loadCategories');
  },
};
</script>
